import { TickOutlined as Tick } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/TickOutlined";
import { InfoOutlined as Info } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/InfoOutlined";
import { InStoreOutlined as ShopFinder } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/InStoreOutlined";
import { DeliveryOutlined as Delivery } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/DeliveryOutlined";
import { ReturnsAndRefundsOutlined as Returns } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ReturnsAndRefundsOutlined";
import { GuaranteesAndTroubleshootingOutlined as Guarantee } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/GuaranteesAndTroubleshootingOutlined";
import { CloseOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/CloseOutlined";

export type ListWithTickProps = {
  cssClasses?: string | undefined;
  textMessage: string;
  dataTestId?: string;
  iconType?: string;
};

const getIcon = (iconName: string) => {
  switch (iconName) {
    case "info":
      return <Info size="medium" />;
    case "shop":
      return <ShopFinder size="medium" />;
    case "delivery":
      return <Delivery size="medium" />;
    case "returns":
      return <Returns size="medium" />;
    case "guarantee":
      return <Guarantee size="medium" />;
    case "close":
      return <CloseOutlined size="medium" />;
    case "2manDelivery":
      return (
        <img
          src="https://static.johnlewiscontent.com/v1/static/2-man-delivery-2"
          alt="2 man delivery icon"
          style={{ width: "24px", height: "24px" }}
        />
      );
    case "tick":
    default:
      return <Tick size="medium" />;
  }
};
export const ListWithIcon = ({
  cssClasses,
  textMessage,
  dataTestId,
  iconType = "tick",
}: ListWithTickProps) => {
  return (
    <li data-testid={dataTestId} className={cssClasses}>
      {getIcon(iconType)}
      <span>{textMessage}</span>
    </li>
  );
};
